import '../scripts/webpackPlugin/react-dom-polyfill';
import React from 'react';
import { GOOGLE_MAP_CHANNEL, initChannel } from '@m2h/common/utils/channelContext';
// import Mach from '@m2h/common/Mach';
import machInit from '@m2h/common/Mach/machInit';
import KNB from '@m2h/common/Mach/KNB';
import '@m2h/common/Mach/machproH5Base/native-worker';
import EventBus from '@m2h/common/utils/eventBus';
import initHTMLElement from '@m2h/common/HTMLElement';
import { clearStoredPageMach } from '@m2h/common/utils/machUtils';
import { reconcileRuntimeLocationState } from '@m2h/common/utils/location';
import './assets/styles/roo';
import './assets/styles/index.css';
import './assets/styles/index.h5.css';
import zhHK from '@roo/roo/locale/lang/zh-TW';
import zh from '@roo/roo/locale/lang/zh-CN';
import en from '@roo/roo/locale/lang/en-US';
import ar from '@roo/roo/locale/lang/ar';
import locale from '@roo/roo/locale';
import {
  getLanguage, isRTL, getCityId, getRegion
} from '@m2h/common/utils';
import { disabledZoom, getFristQueryValue, getLoginAccountId } from '@m2h/common/utils/common';
import { setGrayCookies } from '@m2h/common/utils/grayUtils';

import { initLxAttributionContext } from '@m2h/common/lx/attributionContext';
import polyfillReact from './react-polyfill';
// react补丁for machpro
polyfillReact();
globalThis.Preact = React;

reconcileRuntimeLocationState();
const region = getRegion();
const cityId = getCityId();
const userId = getLoginAccountId();

// 根据定位信息等，设置灰度标记：cookie-mgray/userid
setGrayCookies({ userId });

// @ts-ignore
if (window.__shouldClearStoredPageMach) {
  // 清理data 和 env.schemeParams。只在连续两次刷新间隔小于300ms时执行
  console.log('bundleName', 'clearStoredPageMach');
  clearStoredPageMach();
}

window.KNB = KNB;

// window.Mach = Mach;
window.eventBus = new EventBus();
machInit();

// HTML Runtime 启动时统一初始化一次；URL 无 channel 时恢复支付等跨页面场景保存的值。
const entryChannel = new URLSearchParams(window.location.search).get('channel') || undefined;
initChannel(entryChannel);
// 此处是不更改原有逻辑，只不过把参数从nol===1判断改成了判断googlemap
window.__nol = entryChannel === GOOGLE_MAP_CHANNEL;

// 初始化 HTML 的方法
initHTMLElement();
disabledZoom();

window.owl?.('setTag', {
  area: region,
  cityId,
});

if (window.LXAnalytics) {
  window.LXAnalytics('setCompass', JSON.stringify({ region, cityId }));
  // @ts-ignore
  const tracker = window.LXAnalytics('getTracker');
  if (tracker) {
    tracker('set', 'uid', userId);
    // React Router 切换页面不会重新执行主入口，在首个页面上报前初始化一次即可全程生效。
    initLxAttributionContext(tracker);
  }
}

const defaultLang = getLanguage();
const rooLocaleLangs = {
  'zh-HK': zhHK,
  zh,
  en,
  ar,
};
locale.use(rooLocaleLangs[defaultLang]);
